module.exports = __webpack_public_path__ + "img/ic-heart-blue.98a410f2.svg";